var _path, _circle, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "avatar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(9.5 6)",
    fill: "none",
    stroke: "#00BFAE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M6,18.771V17.514A2.735,2.735,0,0,1,8.911,15h2.911a2.735,2.735,0,0,1,2.911,2.514v1.257",
    transform: "translate(1.633 -1.22)",
    fill: "none",
    stroke: "#00BFAE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    vectorEffect: "non-scaling-stroke"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_1217",
    "data-name": "Path 1217",
    transform: "translate(1 1)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0A11,11,0,0,1,22,11a11.118,11.118,0,0,1-3.744,8.268A10.787,10.787,0,0,1,11,22,11,11,0,0,1,11,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11 1.5 C 5.761680603027344 1.5 1.5 5.761680603027344 1.5 11 C 1.5 16.23831939697266 5.761680603027344 20.5 11 20.5 C 13.32831001281738 20.5 15.65957069396973 19.62808990478516 17.23892974853516 18.16506958007813 C 19.37233924865723 16.19879913330078 20.5 13.72115993499756 20.5 11 C 20.5 5.761680603027344 16.23831939697266 1.5 11 1.5 M 11 0 C 17.07513046264648 0 22 4.924869537353516 22 11 C 22 14.19549942016602 20.63742065429688 17.07275009155273 18.25550079345703 19.2680606842041 C 16.50082969665527 20.89348983764648 13.87963008880615 22 11 22 C 4.924869537353516 22 0 17.07513046264648 0 11 C 0 4.924869537353516 4.924869537353516 0 11 0 Z",
    stroke: "none",
    fill: "#00BFAE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.544ba57c3236fd6a3b74e83005c16fb1.svg";
export { ForwardRef as ReactComponent };